import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateData } from "../redux/roundtoSlice";

export const BehaviourQuestions = ({
  behaviourQuestionsArray = [],
  answers = [],
  handleOptionChange,
  questionRefs = [],
}) => {
  const roundData = useSelector((state) => state.roundData);
  const dispatch = useDispatch()

  const handleOptionSelect = (questionId, optionId) => {
    const updatedQuestions = roundData?.questions.map((question) => {
      if (question.questionId === questionId) {
        return {
          ...question,
          options: question.options.map((option) => ({
            ...option,
            iselected: option.optionId === optionId,
          })),
        };
      }
      return question;
    });

    dispatch(updateData({ field: 'questions', value: updatedQuestions }))

    //    setQuestions(updatedQuestions);
  };


  return (
    <div>
      {roundData?.questions?.map((question, qIndex) => (
        <div
          key={qIndex}
          className="mcqBox"
          ref={(el) => (questionRefs.current[qIndex] = el)}
        >
          <h3 className="">
            {qIndex + 1}. {question.questionText}
          </h3>

          <div className="">
            {question.options.map((option, oIndex) => {


              return (
                <div key={oIndex} className="optnzMCQ">
                  <label>
                    <input
                      type="radio"
                      name={`question-${qIndex}`}
                      checked={option.iselected}
                      onChange={(e) =>
                        handleOptionSelect(question.questionId, option?.optionId)
                      }
                      className=" "
                    />
                    <span className="cursor-pointer">{option.optionText}</span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
